import { useOfficialAccount } from '@/hooks';
import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

export const OfficialAccountRedirect = () => {
  const { officialId } = useParams<{ officialId: string }>() || {};
  const { officialAccountDetail } = useOfficialAccount(officialId);

  if (!officialAccountDetail?.slug) return null;

  return <Redirect to={`/official/${officialAccountDetail?.slug}`} />;
};
